import React, {useEffect} from 'react';
import {can, translate} from "utils/helpers";
import {useContactContext} from "context/ContactContext";
import {Badge, Dropdown} from "antd";
import {IoEllipsisVerticalSharp} from "react-icons/all";
import {Table} from "components/ui";

function ContactTable(props) {

    const {
        translateKey,
        permission,
        handleModal,
        dataSource,
        query,
        tableLoading,
        fetchDataSource,
        handleQuery,
        handleAction,
        handleDelete
    } = useContactContext();

    const columns = [
        {
            title: translate(translateKey + '.Label.Fullname'),
            dataIndex: 'fullname'
        },
        {
            title: translate(translateKey + '.Label.Email'),
            dataIndex: 'email'
        },
        {
            title: translate(translateKey + '.Label.Phone'),
            dataIndex: 'phone',
            render: value => (
                <div className="whitespace-nowrap">{value}</div>
            )
        },
        {
            title: translate(translateKey + '.Label.Message'),
            dataIndex: 'message'
        },
    ];

    const actionRender = (row) => {
        const menus = (
            <div className="dropdown dropdown--sm">
                <div className="dropdown-body">
                    <div className="dropdown-items">
                        {can(permission + '.delete') && (
                            <button
                                className="dropdown-item h-8"
                                onClick={() => handleDelete(row.id)}
                            >
                                {translate('button.Delete')}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        );
        return <Dropdown overlay={menus} placement={'bottomRight'}>
            <button className="btn btn--action bg-gray-100 text-gray-900 dark:bg-transparent dark:text-gray-300">
                <span>
                    <IoEllipsisVerticalSharp/>
                </span>
            </button>
        </Dropdown>
    }

    useEffect(() => {
        fetchDataSource()
    }, [query])

    return (
        <Table
            tableQuery={query}
            setTableQuery={handleQuery}
            dataSource={dataSource.data}
            total={dataSource.total}
            columns={columns}
            loading={tableLoading}
            sortingStart={1}
            actionWidth={40}
            actionButton={row => actionRender(row)}
        />
    );
}

export default ContactTable;
